<template>
  <div class="list-group-item">
    <collapse :selected="false" :id="'fpv-'+fieldData.name">
      <div class="collapsible-header" slot="collapsible-header" @click="expand">
        <h4>{{ form ? form.name : '' }}</h4>
        <div class="actions"><button class="btn default">{{ expanded ? 'Hide' : 'Show' }}</button></div>
      </div>
      <div class="collapsible-body" slot="collapsible-body">
        <vue-good-table v-if="form && form.hasOwnProperty('columns') && form.columns.length"
                        :columns="form.columns"
                        :rows="form.rows"
                        :sort-options="{enabled:true}"
                        :globalSearch="false"
                        :paginate="false"
                        styleClass="table table-bordered show-all-results"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.type === 'date'">{{ props.row[props.column.field] }}</span>
            <span v-else-if="props.column.field === '_date_created'">{{ props.row._date_created.date | formatDateModal  }}</span>
            <span v-else-if="props.column.field === '_date_modified' && props.row._date_modified">{{ props.row._date_modified.date | formatDateModal }}</span>
            <span v-else-if="props.column.field.startsWith('file-')">
              <a
                v-for="(file, index) in formatFileValue(props.column.field, props.formattedRow[props.column.field])"
                :href="file.url"
                :key="`file-${index}`"
                target="_blank"
              >
                <span v-if="index !== 0">, </span>{{ file.name }}
              </a>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </collapse>

  </div>
</template>
<script>

import Collapse from "../Collapse";
import {URL} from '@/http-common';

export default {

  props: ['form', 'fieldData'],

  data() {
    return {
      expanded: false,
      token: localStorage.getItem('id_token'),
    }
  },

  components: {
    Collapse
  },
  methods: {
    expand() {
      this.expanded = !this.expanded;
    },
    formatFileValue(field, value) {
      if (value){
        return JSON.parse(value).map(({name, file}) => {
          return {
            name,
            url: URL +'/form/download/file/'+field.split('-')[1]+'_'+file+'?token='+this.token
          }
        });
      }
    }
  },
}
</script>

<style lang="scss">
.collapsible-header {
  h4 {
    display: inline-block;
    width: calc(100% - 100px);
  }

  .actions {
    float: right;

    button {
      margin-top: 3px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// SharedFieldFormPreview.vue?3006213a